import { render } from "./InstructionsPage.vue?vue&type=template&id=d8c017cc&scoped=true"
import script from "./InstructionsPage.vue?vue&type=script&lang=js"
export * from "./InstructionsPage.vue?vue&type=script&lang=js"

import "./InstructionsPage.vue?vue&type=style&index=0&id=d8c017cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c017cc"]])

export default __exports__